import React from 'react';
import { isAdvancedUser, isDriver } from 'src/common/session/SessionService';
import { Role } from './Role';

export const AdvancedUserOrDriverRole: React.FC = ({ children }) => (
    <Role isRole={session => isAdvancedUser(session) || isDriver(session)}>
        {children}
    </Role>
);
